if (!customElements.get('ggp-variant-coa')) {
  customElements.define(
    'ggp-variant-coa',
    class GgpVariantCoa extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.panels = Array.from(this.querySelectorAll('[data-coa-panel]'));

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
            const detail = payload && payload.data;
            if (!detail) return;
            if (
              this.sectionId &&
              detail.sectionId &&
              String(detail.sectionId) !== String(this.sectionId)
            ) {
              return;
            }
            this.show(detail.variant ? detail.variant.id : null);
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      show(variantId) {
        let target = variantId
          ? this.querySelector('[data-coa-panel][data-coa-variant="' + variantId + '"]')
          : null;
        if (!target) {
          target = this.querySelector('[data-coa-panel][data-coa-variant="default"]');
        }
        this.panels.forEach((p) => {
          p.hidden = p !== target;
        });
      }
    }
  );
}
